import React from 'react';
import { Layout } from '../components/layout';
import { useConfiguration } from '../hooks/useConfiguration';
import { useTranslation } from 'react-i18next';

export const TermsAndConditions = () => {
  const configuration = useConfiguration();

  const { t, i18n } = useTranslation();

  if (configuration === undefined) {
    return null;
  }

  const { copyright } = configuration;
  return (
    <Layout copyright={copyright}>
      <section className='profile'>
        <div className='content'>
          <div className='row'>
            <div className='col-9'>
              <h2 className='profile__title'>{t('termsAndConditions.title')}</h2>
            </div>
          </div>

          <div className='text'>
            <h3 className='par-header'>{t('termsAndConditions.terms.title')}</h3>
            <div className='subpar'>{t('termsAndConditions.terms.paragraph_1')}</div>
            <div className='subpar'>{t('termsAndConditions.terms.paragraph_2')}</div>
            <div className='subpar'>{t('termsAndConditions.terms.paragraph_3')}</div>

            <h3 className='par-header'>{t('termsAndConditions.provision.title')}</h3>
            <div className='subpar'>{t('termsAndConditions.provision.paragraph_1')}</div>
            <div className='subpar'>
              {t('termsAndConditions.provision.paragraph_2')}
              <div className='subpar2'>{t('termsAndConditions.provision.paragraph_2_1')}</div>
              <div className='subpar2'>{t('termsAndConditions.provision.paragraph_2_2')}</div>
            </div>
            <div className='subpar'>{t('termsAndConditions.provision.paragraph_3')}</div>
            <div className='subpar'>{t('termsAndConditions.provision.paragraph_4')}</div>
            <div className='subpar'>
              {t('termsAndConditions.provision.paragraph_5')}
              <div className='subpar2 bullet'>{t('termsAndConditions.provision.paragraph_5_1')}</div>
              <div className='subpar2 bullet'>{t('termsAndConditions.provision.paragraph_5_2')}</div>
              <div className='subpar2 bullet'>{t('termsAndConditions.provision.paragraph_5_3')}</div>
            </div>

            <h3 className='par-header'>{t('termsAndConditions.customerDuty.title')}</h3>
            <div className='subpar'>
              {t('termsAndConditions.customerDuty.paragraph_1')}
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_1_1')}</div>
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_1_2')}</div>
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_1_3')}</div>
            </div>
            <div className='subpar'>
              {t('termsAndConditions.customerDuty.paragraph_2')}
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_2_1')}</div>
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_2_2')}</div>
              <div className='subpar2'>{t('termsAndConditions.customerDuty.paragraph_2_3')}</div>
            </div>

            <h3 className='par-header'>{t('termsAndConditions.support.title')}</h3>
            <div>{t('termsAndConditions.support.paragraph_1')}</div>

            <h3 className='par-header'>{t('termsAndConditions.intellectualProperty.title')}</h3>
            <div className='subpar'>
              {t('termsAndConditions.intellectualProperty.paragraph_1_Title')}
              <div className='subpar-body'>{t('termsAndConditions.intellectualProperty.paragraph_1_Body')}</div>
            </div>
            <div className='subpar'>
              {t('termsAndConditions.intellectualProperty.paragraph_2_Title')}
              <div className='subpar-body'>{t('termsAndConditions.intellectualProperty.paragraph_2_Body')}</div>
            </div>
            <div className='subpar'>
              {t('termsAndConditions.intellectualProperty.paragraph_3_Title')}
              <div className='subpar2'>
                {t('termsAndConditions.intellectualProperty.paragraph_3_1')}
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_1_a')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_1_b')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_1_c')}</div>
              </div>
              <div className='subpar2'>
                {t('termsAndConditions.intellectualProperty.paragraph_3_2')}
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_2_a')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_2_b')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_2_c')}</div>
              </div>
              <div className='subpar2'>
                {t('termsAndConditions.intellectualProperty.paragraph_3_3')}
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_3_a')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_3_b')}</div>
                <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_3_c')}</div>
              </div>
              <div className='subpar2'>{t('termsAndConditions.intellectualProperty.paragraph_3_4')}</div>
            </div>

            <h3 className='par-header'>{t('termsAndConditions.operatorLiability.title')}</h3>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_1')}</div>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_2')}</div>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_3')}</div>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_4')}</div>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_5')}</div>
            <div className='subpar2'>{t('termsAndConditions.operatorLiability.paragraph_6')}</div>

            <h3 className='par-header'>{t('termsAndConditions.generalRegulations.title')}</h3>
            <div className='subpar'>
              {t('termsAndConditions.generalRegulations.paragraph_1')}
              <div className='subpar2'>{t('termsAndConditions.generalRegulations.paragraph_1_1')}</div>
              <div className='subpar2'>{t('termsAndConditions.generalRegulations.paragraph_1_2')}</div>
              <div className='subpar2'>{t('termsAndConditions.generalRegulations.paragraph_1_3')}</div>
            </div>
            <div className='subpar'>
              {t('termsAndConditions.generalRegulations.paragraph_2_title')}
              <div className='subpar-body'>{t('termsAndConditions.generalRegulations.paragraph_2_body')}</div>
            </div>
          </div>
        </div>
        <div className='clear-footer clear-footer--light'></div>
      </section>
    </Layout>
  );
};
